module.exports = __webpack_public_path__ + "static/media/estimate_preview_fr.0a494f79.png";